<app-card rootClass="h-full" contentClass="h-full" bodyClass="h-full">
  <div class="flex flex-col h-full">
    <div class="text-subheading-large text-headingText p-5 pt-4  shrink-0">{{ title || 'Total Investment Volume' }}</div>
    <div class="p-5 flex-1">
      @if (investments.length > 0) {
        <div class="flex items-center gap-3 py-2-5" *ngFor="let item of investments">

          <!-- LEFT : ICON + LABEL -->
          <div class="flex items-center gap-3 flex-1">
            <svg-icon [src]="item.icon" svgClass="w-5 h-5" />
            <span class="text-label-medium-r text-bodyText truncate">
              {{ item.name }}
            </span>
          </div>
  
          <!-- CENTER : PROGRESS -->
          <div class="flex-1 flex items-center gap-3">
            <app-progress-bar [value]="item.value" size="medium" [showValue]="false">
            </app-progress-bar>
            <!-- RIGHT : % VALUE -->
            <div class="text-right text-label-medium-r text-bodyText ">
              {{ item.value }}%
            </div>
          </div>
  
  
        </div>
      } @else {
        <div class="flex items-center justify-center h-full text-bodyText">No data available</div>
      }
    
    </div>
  </div>
</app-card>